import { apiClient } from "./client";

export interface CurvePoint {
  power_kw: number;
  cost_uah_per_mwh: number;
}

export interface CostCurveResponse {
  date: string;
  power_min_kw: number;
  power_max_kw: number;
  power_step_kw: number;
  points: CurvePoint[];
  presets: Record<string, CurvePoint>;
}

export const costCurveApi = {
  get: (date?: string) =>
    apiClient
      .get<CostCurveResponse>("/cost-curve", { params: date ? { date } : undefined })
      .then((r) => r.data),
};
